import { Helmet } from 'react-helmet-async';

export const SEO = ({
                                            title,
                                            description,
                                            keywords,
                                            author = 'Offshore Advisory',
                                            url,
                                            type = 'website',
                                        }) => {
    const siteUrl = 'https://offshoreadvisory.pro'; // Root domain
    const fullUrl = url ? `${siteUrl}${url}` : siteUrl;

    return (
        <Helmet>
            {/* Primary Meta Tags */}
            <title>{title} | Offshore Advisory</title>
            <meta name="title" content={`${title} | Blue Arrow`} />
            <meta name="description" content={description} />
            {keywords && <meta name="keywords" content={keywords} />}
            {author && <meta name="author" content={author} />}

            {/* Open Graph Meta Tags */}
            <meta property="og:type" content={type} />
            <meta property="og:url" content={fullUrl} />
            <meta property="og:title" content={`${title} | Blue Arrow`} />
            <meta property="og:description" content={description} />

            {/* Twitter Meta Tags */}
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:url" content={fullUrl} />
            <meta property="twitter:title" content={`${title} | Blue Arrow`} />
            <meta property="twitter:description" content={description} />

            {/* Canonical URL */}
            <link rel="canonical" href={fullUrl} />
        </Helmet>
    );
};

export default SEO;

